<template>
  <div class="searchBox">
    <a-icon type="search" class="clearIcon" @click="onSearch"/>
    <a-select
      allowClear
      show-search
      :placeholder="placeholderStr"
      class="productSelect"
      :default-active-first-option="false"
      style="width: 200px;"
      :show-arrow="false"
      :filter-option="false"
      :not-found-content="null"
      @search="e => getSearchList(e)"
      @select="onSearch"
      @inputKeydown='inputKeydown'
      v-model="keyword"
    >
      <a-select-option v-for="d in searchList" :key="d.code">
        {{d.firstName}}<span style="color: red">{{d.midName}}</span>{{d.lastName}}({{d.code}})
      </a-select-option>
    </a-select>
  </div>
</template>
<script>
export default {
  props: ['placeholderStr','feild','url'],
  data(){
    return {
      keyword: undefined,
      searchList: []
    }
  },
  methods: {
    onSearch(){
      this.$emit('changeForm',{[this.feild]: this.keyword})
    },
    getSearchList(keyword){
      if(keyword){
        this.keyword = keyword
        setTimeout(() => {
          let params = {
            current: 1,
            size:100,
            factoryId: window.localStorage.getItem('factoryId'),
            keyword
          }
          let url = this.url || '/nhf-app/factoryRaw/pageWithOutSpecialTypeId'
          this.$get(url,params).then(res => {
            let {success,data} = res;
            if(success){
              let {records} = data;
              records.map(el => {
                let nameArr = el.name.split(keyword)
                el.firstName = nameArr[0]
                el.lastName = nameArr[1]
                el.midName = keyword
                return el
              })
              this.searchList = records || []
            }
          }).catch(()=>{
            this.searchList = []
          })
        }, 300);
      }
    },
    inputKeydown(e){
      if(e.keyCode === 13) this.$emit('changeForm',{[this.feild]: this.keyword})
    },
  }
}
</script>
<style lang="scss" scoped>
.searchBox{
  position: relative;
}
.clearIcon{
  position: absolute;
  left: 183px;
  top:5px;
  z-index: 1000;
  color: #ccc;
}
</style>